"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UnsafeUrl = require("../utils/UnsafeUrl");

var _validHref = _interopRequireDefault(require("../utils/propTypes/validHref"));

var _ThrowError = require("../utils/ThrowError");

var _Styles = require("../utils/Styles");

var _Timers = require("../utils/Timers");

var SHAPE_CLASSES = {
  default: '',
  circle: 'img-circle private-image--circle',
  rounded: 'img-rounded private-image--rounded',
  thumbnail: 'img-thumbnail private-image--thumbnail'
};
var OBJECT_FIT_CLASSES = {
  fill: '',
  contain: 'private-image--object-fit-contain'
};

var UIImage =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIImage, _PureComponent);

  function UIImage() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIImage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIImage)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      computedStyle: _this.props.style,
      loadFailed: false,
      overrides: {}
    };

    _this.handleImageError = function (evt) {
      var onError = _this.props.onError;

      _this.setState({
        loadFailed: true
      });

      if (onError) onError(evt);
    };

    _this.handleImageLoad = function (evt) {
      var onLoad = _this.props.onLoad;

      _this.setState({
        loadFailed: false
      });

      if (onLoad) onLoad(evt);
    };

    _this.delayedPolyfillObjectFit = function () {
      (0, _Timers.cancelIdleCallback)(_this._timeout); // Ensure only one callback is queued at a time

      _this._timeout = (0, _Timers.requestIdleCallback)(_this.polyfillObjectFit);
    };

    _this.polyfillObjectFit = function () {
      var _this$props = _this.props,
          objectFit = _this$props.objectFit,
          style = _this$props.style;

      if (!('objectFit' in document.documentElement.style) && objectFit === 'contain' && document.body && _this._img) {
        var _this$_img = _this._img,
            naturalWidth = _this$_img.naturalWidth,
            naturalHeight = _this$_img.naturalHeight;
        if (!naturalWidth || !naturalHeight) return;
        var imgAspectRatio = naturalWidth / naturalHeight; // Reset existing overrides on <img>

        var imgStyles = _this._img.style;
        var originalImgWidth = imgStyles.width;
        var originalImgHeight = imgStyles.height;

        if (_this.state.overrides.width) {
          imgStyles.width = style ? (0, _Styles.toPx)(style.width) : '';
        } else if (_this.state.overrides.height) {
          imgStyles.height = style ? (0, _Styles.toPx)(style.height) : '';
        }

        var _this$_img$getBoundin = _this._img.getBoundingClientRect(),
            renderedWidth = _this$_img$getBoundin.width,
            renderedHeight = _this$_img$getBoundin.height;

        var fittedHeight = renderedWidth / imgAspectRatio;
        var fittedWidth = renderedHeight * imgAspectRatio;
        var overrides = {};

        if (renderedHeight > fittedHeight) {
          overrides = {
            height: fittedHeight
          };
        } else if (renderedWidth > fittedWidth) {
          overrides = {
            width: fittedWidth
          };
        }

        imgStyles.width = originalImgWidth;
        imgStyles.height = originalImgHeight;

        _this.updateOverrides(overrides);
      }
    };

    _this.updateOverrides = function (overrides) {
      var style = _this.props.style;

      _this.setState({
        computedStyle: (0, _extends2.default)({}, style, overrides),
        overrides: overrides
      });
    };

    return _this;
  }

  (0, _createClass2.default)(UIImage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      requestAnimationFrame(this.polyfillObjectFit);
      window.addEventListener('resize', this.delayedPolyfillObjectFit);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // ⚠️ This condition prevents infinite loops! ⚠️
      if (prevState.overrides === this.state.overrides) {
        this.polyfillObjectFit();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.delayedPolyfillObjectFit);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          alt = _this$props2.alt,
          bordered = _this$props2.bordered,
          className = _this$props2.className,
          objectFit = _this$props2.objectFit,
          responsive = _this$props2.responsive,
          shape = _this$props2.shape,
          src = _this$props2.src,
          __style = _this$props2.style,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["alt", "bordered", "className", "objectFit", "responsive", "shape", "src", "style"]);

      if ((0, _UnsafeUrl.isUnsafeUrl)(src)) {
        (0, _ThrowError.throwErrorAsync)(new Error("UIImage: Detected XSS attempt! src=\"" + src + "\""));
      }

      var computedStyle = this.state.computedStyle;
      return _react.default.createElement("img", (0, _extends2.default)({}, rest, {
        alt: alt,
        className: (0, _classnames.default)('private-image', SHAPE_CLASSES[shape], OBJECT_FIT_CLASSES[objectFit], className, {
          'img-responsive private-image--responsive': responsive,
          'image-load-failed': this.state.loadFailed,
          'private-image--bordered': bordered
        }),
        key: src,
        onError: this.handleImageError,
        onLoad: this.handleImageLoad,
        ref: function ref(_ref) {
          _this2._img = _ref;
        },
        src: (0, _UnsafeUrl.isUnsafeUrl)(src) ? null : src,
        style: computedStyle
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      return (0, _extends2.default)({}, state, {
        computedStyle: (0, _extends2.default)({}, props.style, state.overrides)
      });
    }
  }]);
  return UIImage;
}(_react.PureComponent);

exports.default = UIImage;
UIImage.propTypes = {
  alt: _propTypes.default.string.isRequired,
  bordered: _propTypes.default.bool.isRequired,
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  onError: _propTypes.default.func,
  onLoad: _propTypes.default.func,
  objectFit: _propTypes.default.oneOf(Object.keys(OBJECT_FIT_CLASSES)).isRequired,
  responsive: _propTypes.default.bool.isRequired,
  shape: _propTypes.default.oneOf(Object.keys(SHAPE_CLASSES)).isRequired,
  src: _validHref.default.isRequired,
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
UIImage.defaultProps = {
  alt: '',
  bordered: false,
  objectFit: 'fill',
  responsive: true,
  shape: 'default'
};
UIImage.displayName = 'UIImage';
module.exports = exports.default;